
import device from 'bits/device'
import { ResizeObserver } from 'bits/global'
import { observeSizeChange } from 'bits/resize_observer'
import { Component, Prop, Vue } from 'bits/vue'
import ImageThumbnail from 'library/v4/components/ImageThumbnail.vue'
import OzBaseButton from 'library/v4/components/OzBaseButton.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import { getAnchorFromCoordinates, getAnchorFromElement } from 'library/v4/components/OzPopoverModal.vue'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'
import OzWallCard from 'library/v4/components/OzWallCard.vue'
import RelativeTime from 'library/v4/components/relative-time.vue'
import throttle from 'lodash.throttle'
import type { Wall as WallSnakeCase, WallCamelCase as Wall } from 'types'

const GAP_SIZE = 16
const MIN_CARD_WIDTH = 190

/**
 * @displayName Wall Card List
 */

@Component({
  components: { OzIcon, OzBaseButton, OzTextButton, ImageThumbnail, RelativeTime, OzWallCard },
})
export default class DashWallCardList extends Vue {
  OzTextButtonColorScheme = OzTextButtonColorScheme
  containerWidth = 1024
  numCardsPerRowHistory: number[] = []
  resizeObserver: ResizeObserver | null = null

  /**
   * Array of walls to display
   */
  @Prop({ default: [] }) walls!: Wall[] | WallSnakeCase[]
  /**
   * Whether or not to show more button
   */
  @Prop({ required: false, default: true }) xMore!: boolean

  /**
   * The timestamp type to show in the card.
   */
  @Prop({ default: 'updatedAt' }) dateAttribute!: string

  get isTablet(): boolean {
    return device.tablet
  }

  get numOfColumns() {
    return Math.floor((this.containerWidth + GAP_SIZE) / (MIN_CARD_WIDTH + GAP_SIZE))
  }

  get cardWidth() {
    return (this.containerWidth - (this.numOfColumns - 1) * GAP_SIZE) / this.numOfColumns
  }

  measureContainerWidth(_: HTMLElement, contentRect: DOMRectReadOnly): void {
    this.containerWidth = contentRect.width
  }

  mounted(): void {
    this.resizeObserver = observeSizeChange(
      this.$el as HTMLDivElement,
      throttle(this.measureContainerWidth, 100, { leading: true }),
    )
  }

  beforeDestroy(): void {
    this.resizeObserver?.unobserve(this.$el)
  }

  handleMoreButtonClick(wall: Wall, e: PointerEvent): void {
    const popoverAnchor = {
      position: 'side',
      ...getAnchorFromElement(e.target as HTMLElement),
    }
    this.$emit('wall-more', { wall, popoverAnchor })
  }

  handleMoreRightClick(wall: Wall, e: PointerEvent): void {
    const popoverAnchor = {
      position: 'side',
      ...getAnchorFromCoordinates(e.pageX, e.pageY),
    }
    this.$emit('wall-more', { wall, popoverAnchor })
  }
}
